<template>
	<component :is="`lyai-${type}`" :theme="theme" :icon="icon" :id="id" :checked="checked" :title="title" :data="data"
		:settings="settings" @updateData="updateData" :w="w" :h="h" :textStyle="textStyle" :lineStyle="lineStyle">
		<template slot="card-tools">
			<slot name="card-tools" v-bind:theme="theme"></slot>
		</template>
		<template slot="search">
			<slot name="search" v-bind:theme="theme"></slot>
		</template>
	</component>
</template>

<script>
	import lyaiAmap from './lyai-amap.vue'
	import lyaiBar from './lyai-bar.vue'
	import lyaiBmap from './lyai-bmap.vue'
	import lyaiCandle from './lyai-candle.vue'
	import lyaiCount from './lyai-count.vue'
	import lyaiFunnel from './lyai-funnel.vue'
	import lyaiGauge from './lyai-gauge.vue'
	import lyaiHeatmap from './lyai-heatmap.vue'
	import lyaiHistogram from './lyai-histogram.vue'
	import lyaiLine from './lyai-line.vue'
	import lyaiMap from './lyai-map.vue'
	import lyaiPie from './lyai-pie.vue'
	import lyaiRadar from './lyai-radar.vue'
	import lyaiRing from './lyai-ring.vue'
	import lyaiSankey from './lyai-sankey.vue'
	import lyaiScatter from './lyai-scatter.vue'
	import lyaiTree from './lyai-tree.vue'
	import lyaiTable from './lyai-table.vue'
	import lyaiWaterfall from './lyai-waterfall.vue'

	export default {
		name: 'lyai-view-component',
		components: {
			lyaiAmap,
			lyaiBar,
			lyaiBmap,
			lyaiCandle,
			lyaiCount,
			lyaiFunnel,
			lyaiGauge,
			lyaiHeatmap,
			lyaiHistogram,
			lyaiLine,
			lyaiMap,
			lyaiPie,
			lyaiRadar,
			lyaiRing,
			lyaiSankey,
			lyaiScatter,
			lyaiTree,
			lyaiTable,
			lyaiWaterfall
		},
		props: {
			theme: {
				type: String,
				default () {
					return 'gradient-primary'
				}
			},
			icon: {
				type: String,
				default () {
					return 'fas fa-clock'
				}
			},
			id: {
				type: String,
				default () {
					return 'id'
				}
			},
			checked: {
				type: Boolean,
				default () {
					return false
				}
			},
			title: {
				type: String,
				default () {
					return '折线图'
				}
			},
			type: {
				type: String
			},
			data: {
				type: Object
			},
			settings: {
				type: Object
			},
			w: {
				type: Number,
				default () {
					return 12
				}
			},
			h: {
				type: Number,
				default () {
					return 12
				}
			},
			textStyle: {
				type: Object,
				default() {
					return {
						color: "white",//这里是改变字体颜色
						fontSize: 18//字体大小
					}
				}
			},
			lineStyle: {
				type: Object,
				default() {
					return {
						color: "white",//这里是改变字体颜色
						width: 1,//线的大小
						type: "solid"//Y轴线的类型
					}
				}
			}
		},
		methods: {
			updateData(start, end) {
				this.$emit('updateData', start, end)
			}
		}
	}
</script>
